import { OrganizationUpdateErrorCode } from '@app/graphql';

import type { FormFields } from './organization-profile-page';

export type FieldError = {
  fieldName: keyof FormFields;
  code: OrganizationUpdateErrorCode;
};

export type State = {
  fieldErrors: FieldError[] | null;
  status: 'idle' | 'processing' | 'success' | 'failed';
};

export const defaultState: State = {
  fieldErrors: null,
  status: 'idle',
};

export type OrganizationProfilePayload = {
  name: string;
  about: string | null;
  email: string;
  facebookUrl: string | null;
  imageFile?: File;
  linkedinUrl: string | null;
  twitterUrl: string | null;
  websiteUrl: string | null;
};

export type OrganizationProfileSuccessPayload = {
  name: string;
  about: string | null;
  email: string;
  facebookUrl: string | null;
  image: {
    original: string;
    /**
     * Other sizes are needed to reconcile with navBar (redux) store
     */
    small: string;
    large: string;
  };
  linkedinUrl: string | null;
  twitterUrl: string | null;
  websiteUrl: string | null;
};
